module.exports = __webpack_public_path__ + "media/halloween_tipping_tier_3-19adb707f4d0963b88e1e4f3f73e489a.mp3";